export class CustomError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;

  constructor(public override cause: string, public code: string, public override message: string) {
    super(message);
    this.name = 'CustomError';
    this.data = {
      cause,
      code,
      message,
    };
  }
}
